import { useState } from "react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";

const dist = (a, b, c, d) => {
  const r = (x) => (x * Math.PI) / 180;
  const h = Math.sin(r(c - a) / 2) ** 2 + Math.cos(r(a)) * Math.cos(r(c)) * Math.sin(r(d - b) / 2) ** 2;
  return 12742 * Math.asin(Math.sqrt(h));
};

export const nearestHub = (hubs, lat, lng) =>
  hubs.filter((h) => h.lat != null).sort((x, y) => dist(lat, lng, x.lat, x.lng) - dist(lat, lng, y.lat, y.lng))[0];

export const useLocate = () => {
  const { meta, selectHub, t, L } = useApp();
  const [busy, setBusy] = useState(false);
  const locate = () => new Promise((resolve) => {
    if (!navigator.geolocation) { toast.error(t("loc_unavailable")); resolve(false); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      const hub = nearestHub(meta.hubs, coords.latitude, coords.longitude);
      if (hub) {
        if (hub.id === "ottawa-gatineau") localStorage.setItem("dm_side", coords.latitude > 45.435 ? "gatineau" : "ottawa");
        selectHub(hub.id, "geolocation");
        toast.success(t("loc_set", { city: L(hub) }));
      }
      localStorage.setItem("dm_loc_asked", "1");
      setBusy(false); resolve(true);
    }, () => {
      localStorage.setItem("dm_loc_asked", "1");
      toast(t("loc_denied")); setBusy(false); resolve(false);
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 3600000 });
  });
  return { locate, busy };
};
